module.exports = __webpack_public_path__ + "static/media/chart.317ac5cb.png";